"use client";
import React from "react";
import { FlipWords } from "./ui/FlipWords";
import { TextGenerateEffect } from "./ui/TextGenerateEffect";
import AR from "../../src/data/ar.json";
import EN from "../../src/data/en.json";
import '../styles/Hero.css';
import { buildPlatformSignUpUrl } from "../utils/publicFarmPreview";


export const HeroSection = ({ lang }) => {
  const Data = lang === "EN" ? EN["Hero"] : AR["Hero"];
  const Common = lang === "EN" ? EN.common : AR.common;
  const { wordsFarming, wordsGrowing, paragraph, btn } = Data;
  const { staticFarming, staticGrowing } = Common.hero;

  return (
    <section
      id="hero"
      className="relative w-full h-screen flex items-center justify-center bg-transparent text-white px-6 my-3"
    >
      {/* Video Container */}
      <div className="relative w-full h-full overflow-hidden rounded-2xl">
        <video
          className="absolute inset-0 w-full h-full object-cover opacity-60"
          poster="/img/Light/hero.png"
          src={lang === "AR"
            ? "https://firebasestorage.googleapis.com/v0/b/farm-topia.appspot.com/o/LandingPage%2FCTA-AR.mp4?alt=media&token=979f02ed-bd92-41e3-92af-fcbbf5101b8b"
            : "https://firebasestorage.googleapis.com/v0/b/farm-topia.appspot.com/o/LandingPage%2FCTA-EN.mp4?alt=media&token=6a186207-0b1f-4fe6-87c1-0a7d06859954"}
          autoPlay
          loop
          muted
          preload="metadata"
          playsInline
        />
        <div className="absolute inset-0 bg-black z-0 bg-opacity-20 rounded-2xl"></div>
      </div>

      {/* Content: Bold statement and CTA */}
      <div
        dir={lang === "AR" ? "rtl" : "ltr"}
        className="responsive-container"
      >
        <h1 className="responsive-header">
          {staticFarming}{" "}
          <FlipWords className="text-white" words={wordsFarming} lang={lang} />,{" "}
          {staticGrowing}{" "}
          <FlipWords className="text-white" words={wordsGrowing} lang={lang} />
        </h1>

        <div className="responsive-text">
          {/* Pass lang to TextGenerateEffect */}
          <TextGenerateEffect words={paragraph} lang={lang} />
        </div>

        <a
          href={buildPlatformSignUpUrl()}
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="responsive-button">{btn}</button>
        </a>
      </div>



    </section>
  );
};
